<template>
    <div class="home">
        <v-container grid-list-xs>
        <!-- <v-card class="mx-auto overflow-hidden"> -->
        <v-card class="px-4" @click="$router.push('/about')" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
            <v-img
                src="../../public/img/img/zanzibar_beach.jpg"
                class="white--text align-top"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="200px"
            >
        <v-card-title>DreamHolidayTZ</v-card-title>
        <v-card-subtitle class="white--text">Plan the perfect trip...</v-card-subtitle>
        </v-img>
        <v-card-text>Let us guide you to discover the beautiful beaches, landscapes and wildlife of Tanzania!
            <p>Have a look at our selection of safari and tours...</p>
        </v-card-text>
        </v-card>
        <v-divider class="mx-4"></v-divider>
        <v-card class="px-4" @click="$router.push('/safari')" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                    <v-img
                    height="200px"
                    :src="require(`../../public/img/img/destination_ruaha.jpg`)"
                    aspect-ratio="2.75"
                    ></v-img>
                    <v-card-title>Safari</v-card-title>
                    <v-card-subtitle>Discover Tanzanias' wildlife</v-card-subtitle>
                    <v-card-text>Safari is a swahili word meaning journey, travelling, touring. We can organize the safari tour of your choice, allowing you to discover the unspoiled natural beauties of Tanzania.</v-card-text>
                    <v-card-actions>
                        <v-btn ripple
                          text
                          color="deep-purple accent-4"
                        >
                          Read
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <v-divider class="mx-4"></v-divider>
        <v-card class="px-4" @click="$router.push('/zanzibar')" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                    <v-img
                    height="200px"
                    :src="require(`../../public/img/img/destination_mnemba.jpg`)"
                    aspect-ratio="2.75"
                    ></v-img>
                    <v-card-title>Zanzibar</v-card-title>
                    <v-card-subtitle>Enjoy local culture and adventures</v-card-subtitle>
                    <v-card-text>The Zanzibar Archipelago, located in the Indian Ocean 30 km off the coast of Tanzania, is a breathtaking spot to escape from the world. On its main island Unguja, familiarly called Zanzibar, lies Stone Town, an historic trade center with swahili and islamic influences. Its winding lanes present minarets, carved doorways and 19th century landmarks such as the House of Wonders, a former sultan palace. The northern villages of Nungwi and Kendwa have wide beaches lined with hotels.</v-card-text>
                    <v-card-actions>
                        <v-btn ripple
                          text
                          color="deep-purple accent-4"
                        >
                          Read
                        </v-btn>
                    </v-card-actions>
                </v-card>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'Home',
    data(){
        return{
            title: "About Us",
            paragraph1: "We are a Tanzania lovers, who would like to reach out to other people and show them the beauty of this country.",
            paragraph2: "We have visited every province in this amazing country and can put together the perfect holiday tailored to suit you.",
            paragraph3: "For this reason we are in contact with local businesses that offer safari tours. We offer them visibility so that they can sustain their families, and our customers can have the best experiences of wilderness and beach relax, at very affordable prices.",
            paragraph4: "We have a good range of itineraries, wildlife viewing opportunities and we can put together any combination to make the right holiday for you. Whether you prefer 5-star city hotels, luxurious resorts, rustic lodges or country inns, we can arrange it for you."
        }
    }
}
</script>